import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function ProductShowcase() {
  return <section className="pt-10 pb-8 px-4 bg-brand-navy text-white" data-id="element-236">
      <div className="max-w-4xl mx-auto text-center" data-id="element-237">
        <div className="inline-flex items-center justify-center gap-2 bg-brand-primary/20 text-brand-secondary font-bold px-4 py-2 rounded-full mb-4 border border-brand-primary/30" data-id="element-238">
          <span data-id="element-239">❄️</span> EL SISTEMA DEFINITIVO
        </div>

        <h2 className="text-4xl md:text-6xl font-black mb-3" data-id="element-240">
          PACK COMPLETO DE REFRIGERACIÓN
        </h2>

        <p className="text-xl md:text-2xl text-blue-50 max-w-3xl mx-auto mb-6 font-medium" data-id="element-241">
          5 Módulos Maestros con todo lo que necesitás para trabajar y cobrar
          desde el primer día.
        </p>

        <div className="flex justify-center gap-3 mb-8" data-id="element-242">
          {['M1', 'M2', 'M3', 'M4', 'M5'].map(modulo => <div key={modulo} className="w-12 h-12 sm:w-14 sm:h-14 bg-brand-deep rounded-xl shadow-md flex items-center justify-center text-lg sm:text-2xl font-black text-brand-primary border-2 border-white/10" data-id="element-243">
              {modulo}
            </div>)}
        </div>

        <div className="bg-brand-deep p-8 md:p-10 rounded-3xl shadow-2xl border border-white/10 text-left max-w-2xl mx-auto" data-id="element-244">
          <h3 className="text-2xl font-black text-white mb-6 border-b border-white/10 pb-4 text-center" data-id="element-245">
            ¿QUÉ VAS A LOGRAR?
          </h3>
          <ul className="space-y-5" data-id="element-246">
            {['Instalar equipos desde cero con seguridad', 'Diagnosticar fallas sin perder tiempo', 'Reparar aires, heladeras y automotor', 'Presupuestar y cobrar como un profesional', 'Conseguir clientes todo el año'].map((item, i) => <li key={i} className="flex items-center gap-4 text-xl font-bold text-blue-50" data-id="element-247">
                <CheckCircleIcon className="w-8 h-8 text-brand-primary flex-shrink-0" data-id="element-248" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}